import React, { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { adminMaterials, adminDeleteMaterial, adminCreateMaterial, adminWorksheets, adminDeleteWorksheet, adminQuizzes, adminDeleteQuiz } from "@/lib/api";
import { Trash2, Plus, X } from "lucide-react";
import { toast } from "sonner";

const TABS = [["materials", "Materials"], ["worksheets", "Worksheets"], ["quizzes", "Quizzes"]];

function UploadModal({ onClose, onDone }) {
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!file) return;
    setBusy(true);
    try {
      const b64 = await new Promise((res) => {
        const r = new FileReader();
        r.onload = () => res(String(r.result).split(",")[1]);
        r.readAsDataURL(file);
      });
      const type = file.type.startsWith("image") ? "image" : (file.type === "application/pdf" ? "pdf" : "document");
      await adminCreateMaterial({ title: title || file.name, type, mime_type: file.type, file_base64: b64, file_name: file.name });
      toast.success("Uploaded"); onDone(); onClose();
    } catch { toast.error("Upload failed"); } finally { setBusy(false); }
  };
  return (
    <div className="rbl-modal-bg" onClick={onClose}>
      <div className="rbl-modal" onClick={(e) => e.stopPropagation()} data-testid="upload-modal">
        <div style={{ display: "flex", justifyContent: "space-between" }}><h3 style={{ margin: 0 }}>Upload material</h3>
          <button className="rbl-link" onClick={onClose} style={{ border: "none", background: "none" }}><X size={18} /></button></div>
        <form onSubmit={submit}>
          <div className="rbl-field"><label className="rbl-label">Title</label>
            <input className="rbl-input" data-testid="material-title" value={title} onChange={(e) => setTitle(e.target.value)} /></div>
          <div className="rbl-field"><label className="rbl-label">File</label>
            <input type="file" data-testid="material-file" onChange={(e) => setFile(e.target.files[0])} required /></div>
          <button className="rbl-btn block" disabled={busy} data-testid="material-upload">{busy ? "Uploading…" : "Upload"}</button>
        </form>
      </div>
    </div>
  );
}

export default function AdminContent() {
  const [tab, setTab] = useState("materials");
  const [items, setItems] = useState([]);
  const [upload, setUpload] = useState(false);

  const load = () => {
    const fn = tab === "materials" ? adminMaterials : tab === "worksheets" ? adminWorksheets : adminQuizzes;
    fn().then(setItems).catch(() => setItems([]));
  };
  useEffect(() => { load(); }, [tab]);

  const del = async (id) => {
    if (!window.confirm("Delete this item?")) return;
    const fn = tab === "materials" ? adminDeleteMaterial : tab === "worksheets" ? adminDeleteWorksheet : adminDeleteQuiz;
    await fn(id); toast.success("Deleted"); load();
  };

  return (
    <AdminLayout>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h1 className="rbl-h1" style={{ fontSize: 34 }}>Content</h1>
        {tab === "materials" && <button className="rbl-btn" onClick={() => setUpload(true)} data-testid="add-material-btn"><Plus size={16} /> Upload material</button>}
      </div>
      <div className="rbl-tabs">
        {TABS.map(([k, label]) => (
          <button key={k} className={`rbl-lang-btn ${tab === k ? "active" : ""}`} data-testid={`ctab-${k}`} onClick={() => setTab(k)}>{label}{tab === k ? ` (${items.length})` : ""}</button>
        ))}
      </div>
      <div data-testid="content-list">
        {items.map((it) => (
          <div key={it.id} className="rbl-list-item">
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700 }}>{it.title}</div>
              <div style={{ color: "var(--muted)", fontSize: 13 }}>
                {tab === "materials" && `${it.type} · ${it.mime_type || ""}`}
                {tab === "worksheets" && `${(it.fields || []).length} fields`}
                {tab === "quizzes" && `${(it.questions || []).length} questions`}
              </div>
            </div>
            <button className="rbl-icon-btn danger" onClick={() => del(it.id)} data-testid={`del-${it.id}`}><Trash2 size={18} /></button>
          </div>
        ))}
      </div>
      {upload && <UploadModal onClose={() => setUpload(false)} onDone={load} />}
    </AdminLayout>
  );
}
